import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3672dce0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3672dce0&prod&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=3672dce0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3672dce0",
  null
  
)

export default component.exports